/* eslint-disable  @typescript-eslint/no-explicit-any */
/* eslint-disable  @angular-eslint/component-selector */
import { Component, forwardRef, Input } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR, ValidationErrors, Validators } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import { mobilePattern } from '../../shared/constants';
import { ToastrService } from 'ngx-toastr';

@Component({
	selector: 'phone-email-input',
	templateUrl: './phone-input.component.html',
	styleUrl: './phone-input.component.css',
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => PhoneInputComponent),
			multi: true,
		},
	]
})
export class PhoneInputComponent {
	@Input() label = "";
	@Input() id = "";
	@Input() required = false;
	@Input() type = "phone";
	@Input() hasError = false;
	@Input() errors: any = {};
	@Input() customError: any = null;
	values: any[] = [];
	onChange: any;
	onTouched: any;

	constructor(private toastr: ToastrService) { }

	writeValue(value: any): void {
		this.values = value || [];
	}

	registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	removeVal(val: string) {
		const index = this.values.indexOf(val);
		if (index >= 0) {
			this.values.splice(index, 1);
		}
	}

	validateEmail(email: string): ValidationErrors | null {
		const control = new FormControl(email);
		return Validators.email(control);
	}

	add(event: MatChipInputEvent): void {
		const value = (event.value || '').trim();
		let valid = false;
		if (this.type == 'phone') {
			let pattern = mobilePattern;
			valid = pattern.test(value);

		} else {
			valid = this.validateEmail(value) === null ? true : false;
		}
		if (valid) {
			this.values.push(value);
			event.chipInput!.clear();
		} else {
			this.toastr.error("Invalid value.", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
		}
	}
}
